var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 13.1188V10.8812C0 9.55904 1.01949 8.46569 2.27886 8.46569C4.44978 8.46569 5.33733 6.83838 4.24588 4.84239C3.62219 3.69819 3.994 2.21073 5.08546 1.54963L7.16042 0.29101C8.10795 -0.306517 9.33133 0.0494567 9.89505 1.05381L10.027 1.29536C11.1064 3.29136 12.8816 3.29136 13.973 1.29536L14.1049 1.05381C14.6687 0.0494567 15.8921 -0.306517 16.8396 0.29101L18.9145 1.54963C20.006 2.21073 20.3778 3.69819 19.7541 4.84239C18.6627 6.83838 19.5502 8.46569 21.7211 8.46569C22.9685 8.46569 24 9.54632 24 10.8812V13.1188C24 14.441 22.9805 15.5343 21.7211 15.5343C19.5502 15.5343 18.6627 17.1616 19.7541 19.1576C20.3778 20.3145 20.006 21.7893 18.9145 22.4504L16.8396 23.709C15.8921 24.3065 14.6687 23.9505 14.1049 22.9462L13.973 22.7046C12.8936 20.7086 11.1184 20.7086 10.027 22.7046L9.89505 22.9462C9.33133 23.9505 8.10795 24.3065 7.16042 23.709L5.08546 22.4504C3.994 21.7893 3.62219 20.3018 4.24588 19.1576C5.33733 17.1616 4.44978 15.5343 2.27886 15.5343C1.01949 15.5343 0 14.441 0 13.1188Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.4284C13.8935 15.4284 15.4286 13.8934 15.4286 11.9999C15.4286 10.1063 13.8935 8.57129 12 8.57129C10.1064 8.57129 8.57141 10.1063 8.57141 11.9999C8.57141 13.8934 10.1064 15.4284 12 15.4284Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingActive);
export default __webpack_public_path__ + "static/media/setting-active.e14205bc5e466677f77593e597345b4f.svg";
export { ForwardRef as ReactComponent };